import React, { useEffect, useState } from "react";
import '../../styles/AdminGalleryTab.css';
// import './AdminGallery.css'; // 분리한 스타일 파일을 여기서 import 하세요

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function AdminGalleryTab() {
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState("");

  const initialForm = { id: null, title: "", date: "", category: "GALLERY", file: null };
  const [g, setG] = useState(initialForm);
  const [preview, setPreview] = useState(null); 
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  async function load() {
    try {
      const res = await fetch(`${API_BASE}/api/gallery_list.php`, { credentials: "include" });
      const data = await res.json();
      if (!res.ok) return setMsg(data?.error || "Failed to load");
      setItems(Array.isArray(data) ? data : []);
    } catch (e) { setMsg("서버 연결 오류"); }
  }

  useEffect(() => { load(); }, []);

  const showMsg = (text) => {
    setMsg(text);
    setTimeout(() => setMsg(""), 3000);
  };

  const processFile = (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) return showMsg("이미지 파일만 업로드 가능합니다.");
    // if (file.size > 2 * 1024 * 1024) return showMsg("파일 용량이 너무 큽니다. (2MB 제한)");

    const reader = new FileReader();
    reader.onloadend = () => {
      setG({ ...g, file: file });
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // if (file.size > 2 * 1024 * 1024) return showMsg("파일 용량이 너무 큽니다. (2MB 제한)");

    processFile(e.target.files?.[0]);
  };
  
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    processFile(file);
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;
  //   if (file.size > 2 * 1024 * 1024) return showMsg("파일 용량이 너무 큽니다. (2MB 제한)");

  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setG({ ...g, file: file });
  //     setPreview(reader.result);
  //   };
  //   reader.readAsDataURL(file);
  // };

  const openCreateModal = () => {
    setIsEditMode(false);
    setG(initialForm);
    setPreview(null);
    setShowModal(true);
  };

  const startEdit = (item) => {
    setIsEditMode(true);
    setG({ ...item, file: null });
    setPreview(`${API_BASE}${item.image_path}`);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setG(initialForm);
    setPreview(null);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isEditMode && !g.file) return showMsg("이미지를 선택해주세요.");

    const fd = new FormData();
    if (isEditMode) fd.append("id", g.id);
    fd.append("title", g.title);
    fd.append("date", g.date);
    fd.append("category", g.category);
    if (g.file) fd.append("image", g.file);

    const url = isEditMode 
      ? `${API_BASE}/api/admin_gallery_update.php`
      : `${API_BASE}/api/admin_gallery_create.php`;

    const res = await fetch(url, { method: "POST", credentials: "include", body: fd });
    const data = await res.json();
    
    if (!res.ok) return showMsg(data.error || "저장 실패");

    showMsg(isEditMode ? "Updated ✅" : "Saved ✅");
    closeModal();
    load();
  }

  async function del(id) {
    if (!window.confirm("삭제하시겠습니까?")) return;
    const res = await fetch(`${API_BASE}/api/admin_gallery_delete.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ id }),
    });
    if (!res.ok) return showMsg("삭제 실패");
    showMsg("Deleted ✅");
    load();
  }

  return (
    <div className="admin-tab-content">
      {msg && <div className={`admin-toast ${msg.includes('✅') ? 'success' : 'error'}`}>{msg}</div>}

      <div className="admin-list-header">
        <button onClick={openCreateModal} className="admin-btn primary">+ NEW IMAGE</button>
      </div>

      <main className="admin-main-list">
        <section className="admin-card">
          <div className="card-head">
            <h3>GALLERY ASSETS</h3>
            <span className="card-dot"></span>
          </div>
          <div className="admin-gallery-grid">
            {items.map((it) => (
              <div key={it.id} className="gallery-admin-item">
                <div className="gallery-img-container">
                  <img src={`${API_BASE}${it.image_path}`} alt={it.title} />
                  <div className="gallery-item-overlay">
                    <button onClick={() => startEdit(it)} className="icon-btn edit">✎</button>
                    <button onClick={() => del(it.id)} className="icon-btn del">✕</button>
                  </div>
                </div>
                <div className="gallery-item-info">
                  <p className="item-title">{it.title}</p>
                  <p className="item-meta">{it.date} · {it.category}</p>
                </div>
              </div>
            ))}
          </div>
          {items.length === 0 && <p className="empty-msg">등록된 사진이 없습니다.</p>}
        </section>
      </main>

      {/* --- 통합 모달 --- */}
      {showModal && (
        <div className="admin-modal-overlay">
          <div className="admin-card modal-card" style={{maxWidth: '450px', width: '90%'}}>
            <div className="card-head">
              <h3>{isEditMode ? 'EDIT IMAGE' : 'ADD NEW IMAGE'}</h3>
              <button onClick={closeModal} className="close-btn">&times;</button>
            </div>
            
            <form onSubmit={handleSubmit} className="admin-form">
              <div className="input-group">
                <label>Image Preview</label>
                <div 
                  className={`image-upload-wrapper ${isDragging ? 'dragging' : ''}`} 
                  onClick={() => document.getElementById('file-input').click()}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  {preview ? (
                    <img src={preview} alt="preview" className="upload-preview" />
                  ) : (
                    <div className="upload-placeholder">
                      <span>+ Click to Upload</span>
                    </div>
                  )}
                  <input id="file-input" type="file" accept="image/*" onChange={handleFileChange} hidden />
                </div>
              </div>

              <div className="input-group">
                <label>Title</label>
                <input value={g.title} onChange={(e) => setG({ ...g, title: e.target.value })} placeholder="사진 제목" required />
              </div>

              <div className="input-row">
                <div className="input-group">
                  <label>Date</label>
                  <input type="date" value={g.date} onChange={(e) => setG({ ...g, date: e.target.value })} required />
                </div>
                <div className="input-group">
                  <label>Category</label>
                  <input value={g.category} onChange={(e) => setG({ ...g, category: e.target.value })} placeholder="GALLERY" />
                </div>
              </div>

              <div className="form-actions" style={{display: 'flex', gap: '10px', marginTop: '10px'}}>
                <button type="submit" className="admin-btn primary" style={{flex: 1}}>
                  {isEditMode ? 'SAVE CHANGES' : 'UPLOAD'}
                </button>
                <button type="button" onClick={closeModal} className="admin-btn secondary" style={{flex: 1}}>CANCEL</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}